import React from 'react'
import styled from 'styled-components'

const DatePostedFilter = ({ addJobFilter }) => {
  const param = 'date_posted'

  return (
    <StyledJobTypeFilter>
      <div onClick={() => addJobFilter(param, '')} className="filter-item">
        <span className="filter-text">Any Time</span>
      </div>
      <div
        onClick={() => addJobFilter(param, 'Last 24 Hours')}
        className="filter-item"
      >
        <span>Last 24 Hours</span>
      </div>
      <div
        onClick={() => addJobFilter(param, 'Last 3 Days')}
        className="filter-item"
      >
        <span>Last 3 Days</span>
      </div>
      <div
        onClick={() => addJobFilter(param, 'Last Week')}
        className="filter-item"
      >
        <span>Last Week</span>
      </div>
      <div
        onClick={() => addJobFilter(param, 'Last Month')}
        className="filter-item"
      >
        <span>Last Month</span>
      </div>
    </StyledJobTypeFilter>
  )
}

export default DatePostedFilter

const StyledJobTypeFilter = styled.div`
  width: 15.5rem;
  display: flex;
  flex-direction: column;
  padding: 5px;
  background-color: #fff;
  border-radius: 2px;
  border: 1px solid #eeeef6;
  box-shadow: 3px 3px 7px rgba(178, 178, 203, 0.2);
  position: absolute;
  top: 110%;
  left: 24vw;
  z-index: 8;

  .filter-item {
    padding: 1rem 0.5rem;

    &:hover {
      background: #eeeef6;
    }

    .filter-text {
      font-size: 14px;
    }
  }
`
